import { ContextMenu, Dropdown, IconButton, Input, MenuItem, MenuList } from 'bimui';
import './file.less';
import { useEffect, useRef, useState } from 'react';
import { ChangeFileTypeList, FileType, getFileTypeLabel } from '@/declare/enums/file-type';
import dayjs from 'dayjs';
import { deleteFileByUuidList, getFilePathByFileUuid, updateFile } from '@/declare/api/project/file';
import { File } from '@/declare/interface/project/file';
import classNames from 'classnames';
import { ReactComponent as FolderSvg } from './icons/folder.svg';
import { ReactComponent as ImageSvg } from './icons/image.svg';
import { ReactComponent as FunctionSvg } from './icons/function.svg';
import { ReactComponent as ReportSvg } from './icons/report.svg';
import { ReactComponent as DrawingSvg } from './icons/drawing.svg';
import { ReactComponent as PhySvg } from './icons/phy.svg';
import { ReactComponent as OpenFileSvg } from './icons/file.svg';
import { ReactComponent as DownloadSvg } from './icons/download.svg';
import { useNavigate } from 'react-router';
import { message } from 'antd';
import { useParams } from 'react-router';


interface IProps {
    file: File
    userOptions: { label: string, value: string }[]
    active: boolean
    originFile: File
    editingUuid?: string // 当前正在重命名的条目uuid
    onContextMenu: (e) => void
    onSingleSelect: (file: File) => void
    onShiftSelect: (file: File) => void
    onCtrlSelect: (file: File) => void
    onClickDownload: (file: File) => void
    onDoubleClick: (file: File) => void
    generateParentData: () => void
    onFinishEdit: () => void // 完成编辑
}

export default function FileItem(props: IProps) {

    const { active, originFile, editingUuid, onSingleSelect, onCtrlSelect, onShiftSelect, onContextMenu, onClickDownload, onDoubleClick, generateParentData } = props

    const { projectUuid } = useParams()

    /**
     * 文件
     */
    const [file, setFile] = useState<File>(null);
    /**
     * 是否编辑名称
     */
    const [editingName, setEditingName] = useState<boolean>(false);
    /**
     * 是否编辑执行人
     */
    const [editingUser, setEditingUser] = useState<boolean>(false);
    /**
     * 是否编辑类型
     */
    const [editingType, setEditingType] = useState<boolean>(false);
    /**
     * 编辑名称
     */
    const [editName, setEditName] = useState<string>('');
    /**
     * 是否悬浮
     */
    const [hover, setHover] = useState<boolean>(false);

    const navigate = useNavigate();
    const dropdownUserRef = useRef<HTMLDivElement>(null); // 组件引用，处理外部点击
    const dropdownTypeRef = useRef<HTMLDivElement>(null); // 组件引用，处理外部点击


    useEffect(() => {
        setFile(props.file);
        if (editingUuid == props.file.uuid) {
            setEditingName(true);
            setEditName(file?.name);
        }
    }, [props.file, editingUuid])

    /**
     * 右键
     */
    const onRowRightClick = (e: React.MouseEvent) => {
        e.preventDefault();
        onContextMenu(e)
    }

    const getFileIcon = (file: File) => {
        if (!file?.type) return null
        if (file.type == FileType.MODEL_PHYSICS) {
            if (file.uuid == originFile.uuid) {
                return <PhySvg style={{ width: 16, height: 16, marginRight: 4 }} />
            } else {
                return <FolderSvg style={{ width: 16, height: 16, marginRight: 4 }} />
            }
        } else if (file.type == FileType.DRAWING) {
            return <DrawingSvg style={{ width: 16, height: 16, marginRight: 4 }} />
        } else if (file.type == FileType.IMAGE) {
            return <ImageSvg style={{ width: 16, height: 16, marginRight: 4 }} />
        } else if (file.type == FileType.MODEL_FUNCTION) {
            return <FunctionSvg style={{ width: 16, height: 16, marginRight: 4 }} />
        } else if (file.type == FileType.REPORT) {
            return <ReportSvg style={{ width: 16, height: 16, marginRight: 4 }} />
        }
    }

    const changeName = () => {
        if (!props?.file) return;
        if (props.file['name'] == editName) {
            setEditingName(false);
            return;
        }
        updateFile(file?.uuid, { name: editName }).then(res => {
            setFile({ ...file, name: editName })
            if (file.type == FileType.MODEL_PHYSICS) {
                generateParentData()
            }
        }).catch(err => {
            console.log('err', err)
        }).finally(() => {
            setEditingName(false);
            props.onFinishEdit()
        })
    }

    const changeType = (type) => {
        if (!props?.file) return;
        if (props.file['type'] == type) {
            setEditingType(false);
            return;
        }
        updateFile(file?.uuid, { type: Number(type) }).then(res => {
            let newFile = { ...file, type: Number(type) }
            setFile({ ...newFile })
            generateParentData()
        }).catch(err => {
            console.log('err', err)
        }).finally(() => {
            setEditingType(false);
        })
    }

    const changeUser = (userUuid) => {
        if (!props?.file) return;
        if (props.file['userUuid'] == userUuid) {
            setEditingUser(false);
            return;
        }
        const userName = props.userOptions?.find(item => item.value === userUuid)?.label || '';
        updateFile(file?.uuid, { userUuid: userUuid }).then(res => {
            let newFile = { ...file, userUuid: userUuid, userName: userName }
            setFile({ ...newFile })
            generateParentData()
        }).catch(err => {
            console.log('err', err)
        }).finally(() => {
            setEditingUser(false);
        })
    }


    /**
     * 根据e判断点击按下逻辑
     * @param e 
     */
    const onClickSelect = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (!e.shiftKey && !e.ctrlKey) {
            onSingleSelect(file)
        } else if (e.shiftKey) {
            onShiftSelect(file)
        } else if (e.ctrlKey) {
            onCtrlSelect(file)
        }
    }

    // 点击外部时取消下拉框的编辑状态
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownUserRef.current && !dropdownUserRef.current.contains(event.target as Node)) {
                setEditingUser(false);
            }
            if (dropdownTypeRef.current && !dropdownTypeRef.current.contains(event.target as Node)) {
                setEditingType(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className={classNames({
                "body-row": true,
                "body-row-active": active,
            })}
                onContextMenu={(e) => onRowRightClick(e)}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={(e) => onClickSelect(e)}
                onDoubleClick={() => onDoubleClick(file)}
            >
                <div className="body-cell body-cell-name">
                    {!editingName &&
                        <>
                            {/* <SelectDot onClick={(e) => {
                                e.stopPropagation()
                                onCtrlSelect(file)
                            }}
                                hidden={!hover}
                                active={active}
                                style={{ marginRight: 4, cursor: "pointer" }}
                            /> */}
                            {getFileIcon(file)}
                            <span
                            // onDoubleClick={(e) => {
                            //     e.stopPropagation();
                            //     e.preventDefault();
                            //     setEditingName(true);
                            //     setEditName(file?.name);
                            // }}
                            >

                                {file?.name}
                            </span>
                            {hover && (
                                <div style={{ display: 'flex', flexDirection: "row", marginLeft: "auto" }}>
                                    {[FileType.DRAWING, FileType.IMAGE, FileType.REPORT].includes(file.type) && (
                                        <IconButton onClick={(e) => {
                                            e.stopPropagation()
                                            onClickDownload(file)
                                        }}
                                            icon={<DownloadSvg />}
                                        />
                                    )}
                                    {/* <IconButton onClick={onClickFile} icon={<OpenFileSvg />} /> */}

                                </div>)}
                        </>}
                    {editingName && <Input
                        style={{ width: '70%' }}
                        value={editName}
                        autoFocus
                        onChange={(e) => setEditName(e.target.value)}
                        onEnter={changeName}
                        onBlur={changeName}
                    />}
                </div>

                {/* todo */}
                <div className="body-cell body-cell-user" ref={dropdownUserRef}>
                    {!editingUser && <span onDoubleClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        setEditingUser(true);
                    }}>{file?.userName || '待分配'}</span>}
                    {editingUser && <Dropdown
                        style={{ height: 24 }}
                        options={props?.userOptions}
                        value={file?.userUuid}
                        onChange={changeUser}
                    />}
                </div>

                <div className="body-cell body-cell-type" ref={dropdownTypeRef}>
                    {!editingType && <span onDoubleClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        // 项目下的专业物理模型，专业模型，不能修改文件类型
                        if (originFile.uuid == "project" || originFile.uuid == file.uuid) {
                            return
                        }
                        setEditingType(true);
                    }}>{getFileTypeLabel(file?.type?.toString()) || '待选择'}</span>}
                    {editingType && <Dropdown
                        style={{ height: 24 }}
                        options={ChangeFileTypeList}
                        value={file?.type?.toString()}
                        onChange={changeType}
                    />}
                </div>
                <div className="body-cell body-cell-time">
                    <span>{dayjs(file?.gmtCreate).format("YYYY/MM/DD HH:mm:ss")}</span>
                </div>
                <div className="body-cell body-cell-size">
                    <span>{file?.fileSize}</span>
                </div>
            </div>
        </>
    )
}